import {
    Card,
    Statistic,
} from "antd";

interface StatisticCardProps {

    title: string;

    value: number;

    icon: React.ReactNode;

    color: string;

    onClick?: () => void;

}

export default function StatisticCard({

    title,

    value,

    icon,

    color,

    onClick,

}: StatisticCardProps) {

    return (

        <Card
    hoverable
    bordered={false}
    onClick={onClick}
    style={{
        width: "100%",
        borderRadius: 12,
        borderLeft: `5px solid ${color}`,
    }}
>
    <div
        style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
        }}
    >
        <div>
            <div
                style={{
                    color: "#666",
                    fontSize: 15,
                }}
            >
                {title}
            </div>

            <div
                style={{
                    color,
                    fontSize: 36,
                    fontWeight: 700,
                    marginTop: 8,
                }}
            >
                {value}
            </div>
        </div>

        <div
            style={{
                fontSize: 34,
                color,
            }}
        >
            {icon}
        </div>
    </div>
</Card>    );

}